/* Oji Matcha — Article page behaviors
   TOC build, reading progress, table wrapping, AJAX add-to-cart, scroll reveal.
   Loaded with defer; DOM is parsed when this runs. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal — adds .oji-in-view to each .oji-reveal element */
  function initReveal() {
    var targets = document.querySelectorAll('.oji-reveal');
    if (!targets.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('oji-in-view'); });
      return;
    }
    /* OJI FIX (T8): arm the CSS hide only now that we know this script runs
       and IntersectionObserver exists — oji-article.css scopes the
       `.oji-reveal { opacity: 0 }` priming to `.oji-article-ready`. If this
       file never executes, the class never appears and content stays visible. */
    document.documentElement.classList.add('oji-article-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oji-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* Reading progress bar */
  function initProgress() {
    var bar = document.querySelector('.oji-article-progress span');
    var body = document.getElementById('oji-article-content');
    if (!bar || !body) return;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress;
      if (total > 0) {
        progress = Math.min(1, Math.max(0, -rect.top / total));
      } else {
        progress = rect.top < 0 ? 1 : 0;
      }
      bar.style.transform = 'scaleX(' + progress + ')';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* Table of contents from H2s */
  function slugify(text, used) {
    var slug = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
    if (!slug) slug = 'seccion';
    var candidate = slug;
    var i = 2;
    while (used.has(candidate)) {
      candidate = slug + '-' + i;
      i++;
    }
    used.add(candidate);
    return candidate;
  }

  function initToc() {
    var toc = document.getElementById('oji-article-toc');
    var content = document.getElementById('oji-article-content');
    if (!toc || !content) return;
    var wrap = toc.closest('.oji-article-toc-wrap');
    var headings = content.querySelectorAll('h2');
    if (headings.length < 3) {
      (wrap || toc).remove();
      return;
    }
    var list = toc.querySelector('.oji-article-toc__list');
    if (!list) return;
    var used = new Set();
    headings.forEach(function (heading) {
      if (!heading.id) heading.id = slugify(heading.textContent, used);
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        heading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + heading.id);
      });
      item.appendChild(link);
      list.appendChild(item);
    });
    var railQuery = window.matchMedia('(min-width: 1280px)');
    function syncTocOpen() {
      if (railQuery.matches) {
        toc.setAttribute('open', '');
      } else {
        toc.removeAttribute('open');
      }
    }
    syncTocOpen();
    if (typeof railQuery.addEventListener === 'function') {
      railQuery.addEventListener('change', syncTocOpen);
    }
  }

  /* Wrap tables so wide comparison tables scroll horizontally on mobile */
  function initTables() {
    var content = document.getElementById('oji-article-content');
    if (!content) return;
    content.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('oji-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'oji-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* Prefijo de rutas para compatibilidad multi-mercado (mismo patron que
     assets/oji-collection-editorial.js: window.routes.root, cadena vacia en
     el mercado por defecto, sin barra final). */
  function atcRoutesRoot() {
    return (window.routes && window.routes.root) || '';
  }

  /* innerHTML no ejecuta <script>: el fragmento de ajax_side_cart de Ella
     depende de ellos (popover de cantidad, inventario por item). Hay que
     recrear cada nodo script para que el fragmento se comporte igual que
     cuando Ella lo inyecta con jQuery .html(). */
  function atcRunInjectedScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var script = document.createElement('script');
      if (old.src) {
        script.src = old.src;
        if (old.defer) script.defer = true;
      } else {
        script.textContent = old.textContent;
      }
      old.parentNode.replaceChild(script, old);
    });
  }

  /* Repinta el sidebar cart tras un add.js exitoso. Este patron viene de
     openSidebarCart() en assets/oji-collection-editorial.js (leer ese
     archivo primero); se duplica aqui a proposito en vez de refactorizar
     un archivo en produccion, ver task-5 del plan de blog-email-capture.
     Devuelve false si el contenedor del sidebar no esta en el DOM, para
     que quien llama use el respaldo de /cart. */
  function atcOpenSidebarCart() {
    var wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!wrapper) return false;
    document.body.classList.add('cart-sidebar-show');
    fetch(atcRoutesRoot() + '/cart?view=ajax_side_cart', { headers: { Accept: 'text/html' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('side cart view failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        wrapper.innerHTML = html;
        atcRunInjectedScripts(wrapper);
        return fetch(atcRoutesRoot() + '/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        /* Port de halo.dispatchChangeForShippingMessage (theme.js): la barra
           <free-shipping-component> vive FUERA del wrapper repintado y solo
           recalcula al recibir 'change'. */
        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (el) {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      })
      .catch(function () {
        /* el refresco de contenido es best-effort; el sidebar ya esta abierto */
      });
    return true;
  }

  /* AJAX add to cart */
  function initAtc() {
    document.querySelectorAll('.oji-article-atc').forEach(function (button) {
      if (!button.dataset.variantId) return;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var variantId = button.dataset.variantId;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Añadiendo...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to add');
            /* cart:refresh no tenia listeners en todo el tema; se reemplaza
               por el repintado real del sidebar, con respaldo a /cart si el
               contenedor del sidebar no esta presente en la pagina. */
            if (!atcOpenSidebarCart()) {
              window.location.href = atcRoutesRoot() + '/cart';
              return;
            }
            button.textContent = '¡Añadido!';
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          })
          .catch(function () {
            button.textContent = 'Error';
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          });
      });
    });
  }

  initReveal();
  initProgress();
  initToc();
  initTables();
  initAtc();
})();
